import { ReactNode } from 'react';

interface PageTransitionProps {
  children: ReactNode;
}

// Removed key={location.pathname} to prevent component remounting on navigation
// This allows React Query cache to persist and speeds up page transitions
// Animation removed: it added 150-300ms paint delay on every navigation
// and competed with React 18 concurrent transitions. Routes now swap instantly.
export const PageTransition = ({ children }: PageTransitionProps) => {
  return <>{children}</>;
};
